import React from 'react'
import PropTypes from 'prop-types'
import Share from '../../../components/Share'
import DetailsSafe from '../../../components/DetailsSafe'

import './ShareSection.scss'

const ShareSection = ({
  qrCodeDisplayed, clientSdkId, scenarioId, locale, referringWebsite
}) => (
  <div className="share-section">
    <Share
      qrCodeDisplayed={qrCodeDisplayed}
      clientSdkId={clientSdkId}
      scenarioId={scenarioId}
      locale={locale}
      referringWebsite={referringWebsite}
    />
    <DetailsSafe />
  </div>
)

ShareSection.propTypes = {
  qrCodeDisplayed: PropTypes.bool.isRequired,
  clientSdkId: PropTypes.string.isRequired,
  scenarioId: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  referringWebsite: PropTypes.string.isRequired
}

export default ShareSection
